export default __webpack_public_path__ + "static/discord-logo-3bd8c6d6e374077fd4e48019ecfb6d8c.png";